import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Layout from "@/components/tripsi/Layout";
import CinematicPage from "@/pages/CinematicPage";
import CityPage from "@/pages/CityPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import NotFoundPage from "@/pages/NotFoundPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { AppDownloadModal, useDownloadModal } from "@/components/tripsi/AppDownloadModal";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function CityPageWrapper() {
  const { open, openModal, closeModal } = useDownloadModal();
  return (
    <Layout>
      <CityPage onDownload={openModal} />
      <AppDownloadModal open={open} onClose={closeModal} />
    </Layout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<CinematicPage />} />
        <Route path="/cities/:slug" element={<CityPageWrapper />} />
        <Route path="/privacy" element={<Layout><PrivacyPage /></Layout>} />
        <Route path="/terms" element={<Layout><TermsPage /></Layout>} />
        <Route path="/admin" element={<Layout><AdminLogin /></Layout>} />
        <Route path="/admin/dashboard" element={<Layout><AdminDashboard /></Layout>} />
        <Route path="*" element={<Layout><NotFoundPage /></Layout>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
